import { render } from "./SwitchUserModal.vue?vue&type=template&id=132250b8"
import script from "./SwitchUserModal.vue?vue&type=script&lang=js"
export * from "./SwitchUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__